import React, { useEffect } from 'react';
import PropTypes from 'prop-types'
import { withRouter } from "react-router-dom"
import { toast } from "sonner"

const NonAuthLayout = (props) => {
  useEffect(() => {
    const existingToasts = document.querySelectorAll('[data-sonner-toast]')
    if (existingToasts.length > 0) {
      toast.dismiss()
    }
  }, [props.location.pathname]);

  return (
    <React.Fragment>{props.children}</React.Fragment>
  );
}

NonAuthLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object
}

export default withRouter(NonAuthLayout)
